// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from '@/App'
import VueClipboards from 'vue-clipboards'
import router from '@/router/index'
import store from '@/store/index'
import i18n from '@/localization/index'
import Echo from 'laravel-echo'
import Notifications from 'vue-notification'
import Meta from 'vue-meta'
Vue.config.productionTip = false

window.jQuery = window.$ = require('jquery')
require('bootstrap')

window.Pusher = require('pusher-js')
window.Echo = new Echo({
    broadcaster: 'pusher',
    key: process.env.PUSHER_KEY,
    cluster: process.env.PUSHER_CLUSTER
})

// Setup base components
require('./components/index')

// Setup directives
require('./utils/directives/index')

// Setup filters
require('./utils/filters/index')

// Setup VueMultianalitycs
require('./analitycs/index')

// Init VueClipboards
Vue.use(VueClipboards)

// Init VueNotifications
Vue.use(Notifications)

// Init Meta
Vue.use(Meta)

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    i18n,
    render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js